import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { PublicSharedModule } from '../../../public-shared/public-shared.module';
import { SharedModule } from '../../../../shared/shared.module';
import { ForgotPasswordComponent } from './forgot-password.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ReCaptchaModule } from 'angular-recaptcha3';
import constantURL from 'src/app/shared/constantURL';

const forgotPasswordRoutes: Routes = [
  { path: '', component: ForgotPasswordComponent },
];

@NgModule({
  declarations: [
    ForgotPasswordComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(forgotPasswordRoutes),
    PublicSharedModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    ReCaptchaModule.forRoot({
      invisible: {
        sitekey: constantURL.RECAPTCHA_KEY,
      },
      normal: {
        sitekey: constantURL.RECAPTCHA_KEY,
      },
      language: 'en',
    }),
  ]
})
export class ForgotPasswordModule { }
